import { Component, Input, OnInit } from '@angular/core';
import { COLUMN_TYPE, TableConfig } from '@d-components/table/table.interface';
import { ApprovedFlowStatus, EntityStatus } from '@d-constants';
import { IProductName } from '@d-models/services/product-name.model';
import { ModalService } from '@d-services';
import { BaseTableComponent } from '@d-components/table/table.component';
import { BaseButtonComponent } from '@d-components/button/button.component';

@Component({
  selector: 'app-revision-history-modal',
  templateUrl: './revision-history-modal.component.html',
  imports: [BaseTableComponent, BaseButtonComponent],
  standalone: true,
})
export class RevisionHistoryModalComponent implements OnInit {
  @Input() data;
  revisionHistory = [];
  tableConfig = {
    columnsConfig: [
      {
        columnName: 'DATE_TIME',
        dataField: 'updatedDateTime',
        type: COLUMN_TYPE.DateFormat,
        cssContainer: 'max-w-6rem',
      },
      {
        columnName: 'REVISION_NO',
        dataField: 'revision',
      },
      {
        columnName: 'ACTION_TYPE',
        dataField: 'actionType',
      },
      {
        columnName: 'APPROVAL_STATUS',
        dataField: 'approvalFlowStatus',
        type: COLUMN_TYPE.Status,
        statusOptions: ApprovedFlowStatus,
      },
      {
        columnName: 'ENTITY_STATUS',
        dataField: 'status',
        type: COLUMN_TYPE.Status,
        statusOptions: EntityStatus,
      },
      {
        columnName: 'AUTHOR',
        dataField: 'updatedBy',
        cssContainer:
          'max-w-6rem white-space-nowrap overflow-hidden text-overflow-ellipsis',
      },
      {
        columnName: 'REMARK',
        dataField: 'remarks',
        cssContainer:
          'max-w-12rem white-space-nowrap overflow-hidden text-overflow-ellipsis',
      },
    ],
  };
  constructor(private modalService: ModalService) {}

  ngOnInit(): void {
    if (this.data.loadData) {
      this.data.loadData({}).subscribe((res) => {
        this.revisionHistory = res;
      });
    }
  }

  closeModal() {
    this.modalService.closeModal({
      actionType: 'cancel',
    });
  }
}
